import React from 'react';
import { FormInput } from 'form/FormInput';
import { Icon, TextArea as UITextArea } from 'lmc-ui-library';
import { ComponentProps } from 'lmc-ui-library/lib/components/atoms/TextArea/TextArea.types';

interface Props extends FormInput, ComponentProps {
  wrapperStyle?: React.CSSProperties;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, Props>(({ state, wrapperStyle, ...props }, ref) => {
  const componentProps: ComponentProps = { ...props };

  if (state === 'error') {
    componentProps.state = 'error';
    componentProps.rightIcon = (stateColor) => <Icon type="error" color={stateColor} />;
  }

  if (state === 'warning') {
    componentProps.state = 'warning';
    componentProps.rightIcon = (stateColor) => <Icon type="warning" color={stateColor} />;
  }

  return (
    <div style={wrapperStyle}>
      <UITextArea {...componentProps} ref={ref} />
    </div>
  );
});

export default TextArea;
